import { Cell } from '../grid/Cell'
import { BaseModal } from './BaseModal'
import { WORD_COUNT } from '../../constants/countSpecific'
import { WORD_LENGTH } from '../../constants/settings'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

export const InfoModal = ({ isOpen, handleClose }: Props) => {
  return (
    <BaseModal title="How to play" isOpen={isOpen} handleClose={handleClose}>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        Reveal the
        {WORD_COUNT === 2 && ' pair of '}
        {WORD_COUNT === 3 && ' three '}
        {WORD_COUNT === 4 && ' four '}
        unrelated random 5 letter words in 6 tries or fewer. After each guess,
        the color of the tiles will change to show how close your guess was to
        the words.
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell
          value="T"
          isRevealing={true}
          isCompleted={true}
          status="correct"
        />
        <Cell value="E" />
        <Cell value="A" />
        <Cell value="R" />
        <Cell value="Y" />
        <Cell value="S" position={WORD_LENGTH} />
        <Cell value="E" />
        <Cell value="V" />
        <Cell value="E" />
        <Cell value="N" />
        {WORD_COUNT >= 3 && <Cell value="L" position={WORD_LENGTH} />}
        {WORD_COUNT >= 3 && <Cell value="Y" />}
        {WORD_COUNT >= 3 && <Cell value="M" />}
        {WORD_COUNT >= 3 && <Cell value="P" />}
        {WORD_COUNT >= 3 && <Cell value="H" />}
        {WORD_COUNT >= 4 && <Cell value="Q" position={WORD_LENGTH} />}
        {WORD_COUNT >= 4 && <Cell value="U" />}
        {WORD_COUNT >= 4 && <Cell value="E" />}
        {WORD_COUNT >= 4 && <Cell value="U" />}
        {WORD_COUNT >= 4 && <Cell value="E" />}
      </div>
      {WORD_COUNT === 2 && (
        <p className="text-sm text-gray-500 dark:text-gray-300">
          The letter T is in the first word and in the correct spot. Note: There
          may be other T's in the first word or the second word.
        </p>
      )}
      {WORD_COUNT > 2 && (
        <p className="text-sm text-gray-500 dark:text-gray-300">
          The letter T is in the first word and in the correct spot. Note: There
          may be other T's in the first word and/or in any of the other words.
        </p>
      )}

      <div className="flex justify-center mb-1 mt-4">
        <Cell value="C" />
        <Cell value="A" />
        <Cell value="R" />
        <Cell value="G" />
        <Cell value="O" />
        <Cell value="P" position={WORD_LENGTH} />
        <Cell value="A" />
        <Cell
          value="L"
          isRevealing={true}
          isCompleted={true}
          status="present"
        />
        <Cell value="E" />
        <Cell value="R" />
        {WORD_COUNT >= 3 && <Cell value="G" position={WORD_LENGTH} />}
        {WORD_COUNT >= 3 && <Cell value="L" />}
        {WORD_COUNT >= 3 && <Cell value="Y" />}
        {WORD_COUNT >= 3 && <Cell value="P" />}
        {WORD_COUNT >= 3 && <Cell value="H" />}
        {WORD_COUNT >= 4 && <Cell value="B" position={WORD_LENGTH} />}
        {WORD_COUNT >= 4 && <Cell value="E" />}
        {WORD_COUNT >= 4 && <Cell value="A" />}
        {WORD_COUNT >= 4 && <Cell value="U" />}
        {WORD_COUNT >= 4 && <Cell value="X" />}
      </div>

      {WORD_COUNT === 2 && (
        <p className="text-sm text-gray-500 dark:text-gray-300">
          The letter L is in the second word but in the wrong spot. Note: there
          may be other L's in the second word and/or in the first word.
        </p>
      )}
      {WORD_COUNT > 2 && (
        <p className="text-sm text-gray-500 dark:text-gray-300">
          The letter L is in the second word but in the wrong spot. Note: there
          may be other L's in the second word and/or in any of the other words.
        </p>
      )}

      <div className="flex justify-center mb-1 mt-4">
        <Cell value="V" />
        <Cell value="A" />
        <Cell value="G" />
        <Cell value="U" />
        <Cell value="E" />
        <Cell value="T" position={WORD_LENGTH} />
        <Cell value="A" />
        <Cell value="R" />
        <Cell
          value="P"
          isRevealing={true}
          isCompleted={true}
          status="otherword"
        />
        <Cell value="S" />
        {WORD_COUNT >= 3 && <Cell value="M" position={WORD_LENGTH} />}
        {WORD_COUNT >= 3 && <Cell value="Y" />}
        {WORD_COUNT >= 3 && <Cell value="R" />}
        {WORD_COUNT >= 3 && <Cell value="R" />}
        {WORD_COUNT >= 3 && <Cell value="H" />}
        {WORD_COUNT >= 4 && <Cell value="O" position={WORD_LENGTH} />}
        {WORD_COUNT >= 4 && <Cell value="U" />}
        {WORD_COUNT >= 4 && <Cell value="I" />}
        {WORD_COUNT >= 4 && <Cell value="J" />}
        {WORD_COUNT >= 4 && <Cell value="A" />}
      </div>
      {WORD_COUNT > 2 && (
        <p className="text-sm text-gray-500 dark:text-gray-300">
          The letter P isn't in the second word, but is in one or more of the
          other words.
        </p>
      )}
      {WORD_COUNT === 2 && (
        <p className="text-sm text-gray-500 dark:text-gray-300">
          The letter P isn't in the second word, but is in the first word.
        </p>
      )}

      <div className="flex justify-center mb-1 mt-4">
        <Cell value="T" />
        <Cell value="R" />
        <Cell value="I" />
        <Cell value="C" isRevealing={true} isCompleted={true} status="absent" />
        <Cell value="K" />
        <Cell value="F" position={WORD_LENGTH} />
        <Cell value="L" />
        <Cell value="A" />
        <Cell value="S" />
        <Cell value="K" />
        {WORD_COUNT >= 3 && <Cell value="S" position={WORD_LENGTH} />}
        {WORD_COUNT >= 3 && <Cell value="Y" />}
        {WORD_COUNT >= 3 && <Cell value="L" />}
        {WORD_COUNT >= 3 && <Cell value="P" />}
        {WORD_COUNT >= 3 && <Cell value="H" />}
        {WORD_COUNT >= 4 && <Cell value="A" position={WORD_LENGTH} />}
        {WORD_COUNT >= 4 && <Cell value="D" />}
        {WORD_COUNT >= 4 && <Cell value="I" />}
        {WORD_COUNT >= 4 && <Cell value="E" />}
        {WORD_COUNT >= 4 && <Cell value="U" />}
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        The letter C is not in any of the words.
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell value="X" isValid={false} />
        <Cell value="Y" isValid={false} />
        <Cell value="Z" isValid={false} />
        <Cell value="Z" isValid={false} />
        <Cell value="Y" isValid={false} />
        <Cell position={WORD_LENGTH} />
        <Cell />
        <Cell />
        <Cell />
        <Cell />
        {WORD_COUNT >= 3 && <Cell position={WORD_LENGTH} />}
        {WORD_COUNT >= 3 && <Cell />}
        {WORD_COUNT >= 3 && <Cell />}
        {WORD_COUNT >= 3 && <Cell />}
        {WORD_COUNT >= 3 && <Cell />}
        {WORD_COUNT >= 4 && <Cell position={WORD_LENGTH} />}
        {WORD_COUNT >= 4 && <Cell />}
        {WORD_COUNT >= 4 && <Cell />}
        {WORD_COUNT >= 4 && <Cell />}
        {WORD_COUNT >= 4 && <Cell />}
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        XYZZY is not a valid word, so it is highlighted.
      </p>
      <p className="mt-6 italic text-sm text-gray-500 dark:text-gray-300">
        <a href="/" className="underline font-bold">
          Other games and info
        </a>{' '}
      </p>
    </BaseModal>
  )
}
